// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"d51fa460","678":"e0ac2925","893":"1b1c8b17"}[chunkId] + ".css";
};